import { useTranslation } from 'react-i18next';
import { Button, Col, Collapse, CollapseProps, Drawer, Form, message, Modal, Row, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { CloseOutlined, ExclamationCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { RuleObject } from 'antd/es/form';
import { StoreValue } from 'antd/es/form/interface';
import _, { isEmpty } from 'lodash';
import FormItemDropdown from "../../../../components/form-dropdown/FormItemDropdown";
import FormInput from "../../../../components/form-input/FormInput";
import { Permission } from '../../../../layout/sidebar/permission.enum';
import { createLecturerAccount, getAllTeacherByUniversity, getDetailTeacherAccount, updateLecturerAccount } from '../../../../service/list-account-teachers/listAccountTeachersApi';
import { getAllEnterpriseUniversityVer2, getRoleDefaultAccount } from '../../../../service/management-participate-platform';
import { globalStore } from '../../../../stores/stores';
import { regexEmail, regexPassword } from '../../../../utils/regex';
import "./index.scss";

type Props = {
  open: boolean
  handleClose: () => void
  fetchData: () => void
  detailData: any;
  mode: string
}

const FormCreateTeacher = (props: Props) => {
  const { t } = useTranslation();
  const { open, handleClose, fetchData, detailData, mode } = props
  const [form] = Form.useForm()
  const { Panel } = Collapse;
  const [status, setStatus] = useState<number>(1)
  const [listEnterprise, setListEnterprise] = useState<any>([]);
  const [listTeacher, setListTeacher] = useState<any>([]);
  const [listRole, setListRole] = useState<any>([]);
  const [requestChoose, setRequestChoose] = useState<any>(0)
  const [dataDetail, setDataDetail] = useState<any>({})
  const { personalInfo, reload } = globalStore();
  const permissions = personalInfo?.permissions;

  const validations = {
    phone: {
      required: true,
      message: t("Vui lòng nhập số điện thoại", "Vui lòng nhập số điện thoại")
    },
    enterprise: {
      required: true,
      message: t("Vui lòng chọn giảng viên", "Vui lòng chọn giảng viên")
    },
    emailContact: [
      {
        required: true,
        message: t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator: (_: unknown, value: any) => {
          if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
            return Promise.reject(
              new Error(t("Định dạng email không đúng, vui lòng nhâp lại", "Định dạng email không đúng, vui lòng nhâp lại"))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    trainingFacility: {
      required: true,
      message: t("Vui lòng chọn cơ sở đào tạo", "Vui lòng chọn cơ sở đào tạo")
    },
    emailLogin: [
      {
        required: true,
        message: t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator: (_: unknown, value: any) => {
          if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
            return Promise.reject(
              new Error(t("Định dạng email không đúng, vui lòng nhâp lại", "Định dạng email không đúng, vui lòng nhâp lại"))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    roleLogin: {
      required: true,
      message: t("Vui lòng chọn vai trò", "Vui lòng chọn vai trò")
    },
    passwordLogin: [
      {
        required: dataDetail?.id ? false : true,
        message: t("Vui lòng nhập mật khẩu", "Vui lòng nhập mật khẩu"),
      },
      {
        min: 8,
        max: 25,
        message: t("Độ dài mật khẩu từ 8-25 ký tự.", "Độ dài mật khẩu từ 8-25 ký tự."),
      },
      {
        pattern: regexPassword,
        message:
          t("Mật khẩu phải bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, và có độ dài từ 8-25 ký tự.", "Mật khẩu phải bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, và có độ dài từ 8-25 ký tự."),
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator(_: RuleObject, value: StoreValue) {
          if (value && getFieldValue("oldPassword") === value) {
            return Promise.reject(
              new Error(t("Mật khẩu mới phải khác mật khẩu hiện tại.", "Mật khẩu mới phải khác mật khẩu hiện tại."))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    passwordLoginConfirm: [
      {
        required: dataDetail?.id ? false : true,
        message: t("Vui lòng xác nhập mật khẩu mới", "Vui lòng xác nhập mật khẩu mới"),
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator(_: RuleObject, value: StoreValue) {
          if (!isEmpty(value)) {
            if (getFieldValue("passwordLogin") === value) {
              return Promise.resolve();
            }
            return Promise.reject(
              new Error(t("Mật khẩu không khớp.", "Mật khẩu không khớp."))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
  }

  useEffect(() => {
    const university = listEnterprise.find((item: any) => item?.uuid === localStorage.schoolManagement || personalInfo?.enterpriseUUID);
    if (university && open) {
      form.setFieldValue("trainingFacility", university?.id);
    }
  }, [listEnterprise, open])

  const blockOne = () => (
    <>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="trainingFacility" label={t("Cơ sở đào tạo", "Cơ sở đào tạo")} rules={[validations.trainingFacility]}>
            <FormItemDropdown
              options={listEnterprise}
              allowClear={true}
              placeholder={t("Chọn cơ sở đào tạo", "Chọn cơ sở đào tạo")}
              onChange={setRequestChoose}
              disabled={permissions?.includes(Permission.isQTCS) || localStorage.schoolManagement}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="enterprise" label={t("Giảng viên", "Giảng viên")} rules={[validations.enterprise]}>
            <FormItemDropdown
              options={listTeacher}
              allowClear={true}
              placeholder={t("Chọn giảng viên", "Chọn giảng viên")}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )

  const blockTwo = () => (
    <>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="emailLogin" label={t("Email đăng nhập", "Email đăng nhập")} rules={validations.emailLogin}>
            <FormInput
              placeholder={t("Nhập email đăng nhập", "Nhập email đăng nhập")}
              autoComplete="new-password"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="roleLogin" label={t("Vai trò", "Vai trò")} rules={[validations.roleLogin]}>
            <FormItemDropdown
              options={listRole}
              allowClear={true}
              placeholder={t("Chọn vai trò", "Chọn vai trò")}
              modeDropdown="multiple"
            />
          </Form.Item>
        </Col>
      </Row>
      {
        dataDetail?.id ? null :
          <Row gutter={24} className="">
            <Col span={12}>
              <Form.Item name="passwordLogin" label={t("Mật khẩu", "Mật khẩu")} rules={validations.passwordLogin}>
                <FormInput
                  placeholder={t("Nhập mật khẩu cho tài khoản", "Nhập mật khẩu cho tài khoản")}
                  passwordInput={true}
                  style={{ height: '32px' }}
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="passwordLoginConfirm" label={t("Xác nhận mật khẩu", "Xác nhận mật khẩu")} rules={validations.passwordLoginConfirm}>
                <FormInput
                  placeholder={t("Xác nhận mật khẩu cho tài khoản", "Xác nhận mật khẩu cho tài khoản")}
                  passwordInput={true}
                  style={{ height: '32px' }}
                />
              </Form.Item>
            </Col>
          </Row>
      }
      <Row gutter={24} className="">
        <Col span={24}>
          <Form.Item name="status" label={t("Trạng thái", "Trạng thái")}>
            <Space.Compact block>
              <Button className={status === 1 ? 'active' : ''} onClick={() => setStatus(1)}>{t("Mở khóa", "Mở khóa")}</Button>
              <Button className={status === 2 ? 'active' : ''} onClick={() => setStatus(2)}>{t("Khóa", "Khóa")}</Button>
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>
    </>
  )

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: <Typography.Title level={5}><strong>{t("Thông tin giảng viên", "Thông tin giảng viên")}</strong></Typography.Title>,
      children: blockOne(),
    },
    {
      key: '2',
      label: <Typography.Title level={5}><strong>{t("Thông tin tài khoản", "Thông tin tài khoản")}</strong></Typography.Title>,
      children: blockTwo(),
    },
  ];

  const createAccount = async (values: any) => {
    const data = {
      userProfileId: values.enterprise,
      username: values.emailLogin,
      password: values.passwordLogin,
      confirmPassword: values.passwordLoginConfirm,
      status: status === 1 ? true : false,
      roleIds: _.isArray(values.roleLogin) ? values.roleLogin : [values.roleLogin],
      universityIds: [values?.trainingFacility]
    }
    if (dataDetail?.id) {
      await updateLecturerAccount(detailData?.id, data).then((res) => {
        if (res.status === 200) {
          message.success(t("Sửa tài khoản thành công", "Sửa tài khoản thành công"))
        }
      })
    } else {
      await createLecturerAccount(data).then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo tài khoản thành công", "Tạo tài khoản thành công"))
        }
      })
    }
    handleClose()
    form.resetFields()
    fetchData()
    setDataDetail([])
  }

  //lay danh sach yeu cau tham gia nen tang
  const getEnterprise = async () => {
    await getAllEnterpriseUniversityVer2({})
      .then((res) => {
        const listOption = res?.data?.data?.map((item: any) => ({
          id: item?.universityId,
          name: item?.name,
          uuid: item?.uuid,
        }))
        setListEnterprise(listOption)
      })
  }

  //lay giang vien theo truong
  const getDetailRequest = async (id: number) => {
    await getAllTeacherByUniversity(id).then((res) => {
      if (res.status === 200) {
        setListTeacher(res.data.data)
      }
    })
  }

  //lay danh sach vai trò default
  const getRoleDefault = async () => {
    const data = {
      keyword: "",
      pageNumber: 1,
      pageSize: 999999,
      checkRole: "2"
    }
    await getRoleDefaultAccount(data)
      .then((res) => {
        if (!isEmpty(res.data.data)) {
          setListRole(res.data.data)

          if (mode === "add" && open) {
            form.setFieldValue("roleLogin", res.data?.data?.filter((item: any) => item.default?.split(',').includes("2"))
              .map((item: any) => item.id))
          }
        }
      })
  }

  //lay chi tiet tai khoản giảng viên
  const getListDataDetail = async () => {
    await getDetailTeacherAccount(detailData?.id).then((res) => {
      if (res.status === 200) {
        const detail = res.data?.data
        setDataDetail(res.data?.data)
        if (mode !== "add") {
          form.setFieldsValue({
            managementAgency: detail?.universityRegisterId ? detail?.universityRegisterId : undefined,
            contactPeople: detail?.userContact,
            contactRolePeople: detail?.userContactPositionId,
            phone: detail?.userContactPhone,
            emailContact: detail?.userContactEmail,
            trainingFacility: detail?.unitId,
            emailLogin: detail?.username,
            enterprise: detail?.userProfileId,
            roleLogin: detail?.roles?.map((item: any) => { return item.id }),
          })
        }
        setRequestChoose(detail?.unitId)
        setStatus(detail?.isActive ? 1 : 2)
      }
    })
  }

  useEffect(() => {
    if (open) {
      const university = listEnterprise.find((item: any) => item?.uuid === localStorage.schoolManagement || personalInfo?.enterpriseUUID);
      if (requestChoose !== 0 && requestChoose !== undefined || university) {
        getDetailRequest(requestChoose || university?.id)
      } else {
        form.resetFields()
      }
    }
  }, [requestChoose, listEnterprise, detailData, open])

  useEffect(() => {
    getEnterprise()
    getRoleDefault()
  }, [reload])

  useEffect(() => {
    if (detailData?.id) {
      getListDataDetail();
    } else {
      form.resetFields()
    }
  }, [detailData])

  const clearFilter = () => {
    form.resetFields()
    setDataDetail([])
    handleClose()
  }

  return (
    <>
      <Form.Provider onFormFinish={(name, { values, forms }) => {
        if (name === "form-create-account-lecturer") {
          Modal.confirm({
            title: t("Xác nhận tạo tài khoản", "Xác nhận tạo tài khoản"),
            content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi xác nhận.", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi xác nhận."),
            onOk: () => {
              createAccount(values)
            },
            okText: t("Xác nhận", "Xác nhận"),
            cancelText: t("Huỷ", "Huỷ"),
            centered: true,
            icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
            footer: (_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            ),
          });
        }
      }}>
        <Drawer
          title={`${mode === "edit" ? t("Sửa", "Sửa") : t("Tạo", "Tạo")} ${t("tài khoản giảng viên", "tài khoản giảng viên")}`}
          open={open}
          onClose={clearFilter}
          width={736}
          extra={
            <Space>
              <Button onClick={() => {
                form.resetFields()
                clearFilter()
              }} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary"
                onClick={() => form.submit()
                }>
                <SaveOutlined />
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
        >
          <Form
            className="create-form-facility-management"
            layout={"vertical"}
            form={form}
            name="form-create-account-lecturer"
            autoComplete='off'
            initialValues={{ emailLogin: '', passwordLogin: '' }}
          >
            <Collapse defaultActiveKey={['1', '2']} ghost items={items} />
          </Form>
        </Drawer>
      </Form.Provider>
    </>
  );
};

export default FormCreateTeacher;
